import { TimeoutStepSchema } from '@feedyou/schema'
import { isNotEmptyElement } from '@feedyou/utils'

import { GetUsedDialogs } from '../../../types'

export const getUsedDialogs: GetUsedDialogs<TimeoutStepSchema> = (
  { dialog, onTimeoutDialog, disabled },
  enabledOnly = false
) => {
  if (enabledOnly && disabled) {
    return []
  }

  return [dialog, onTimeoutDialog].filter(isNotEmptyElement)
}
